import { AppForms } from '@/app'
import { useForm } from '@codeleap/common'
import React from 'react'
import { profilePromptStore } from '@/stores'
import { APIClient } from '@/services'
import { TypeGuards } from '@codeleap/types'
import { AppStatus } from '@/redux'
import { CommunityFeed } from '@/types'
import type { Profile } from '@/services/api/session/views'

export function useProfilePrompt(item: CommunityFeed, overrideKey?: keyof Profile) {
  const key = overrideKey ?? item?.profile_prompt?.key

  const { data: profile } = APIClient.Session.useProfile()
  const updateProfile = APIClient.Session.useUpdateProfile()

  const form = useForm(AppForms.editProfile, { initialState: { ...profile, ...profilePromptStore.store.get() }})

  const onUpdateProfile = React.useCallback(async () => {
    const fieldValue = form.values[key]

    if (!profilePromptStore.isAnswerValue(fieldValue)) return

    try {
      const payload =
        key === 'organization' && TypeGuards.isObject(fieldValue)
          ? { ...profile, organization: (fieldValue as any).id }
          : { ...profile, organization: profile?.organization?.id, [key]: fieldValue }

      if (payload?.referral_code) delete payload.referral_code

      AppStatus.set('loading')

      const updatedProfile = await updateProfile.mutateAsync(payload as any)
      APIClient.Session.QueryKeys.me.refresh()

      profilePromptStore.answerPrompt(key, updatedProfile?.[key] ?? fieldValue)

      AppStatus.set('done')
    } catch (error) {
      AppStatus.set('idle')
      logger.error('Error updating profile', error, `Profile Prompt - ${key}`)
    }
  }, [form, key])

  const isAnswered = profilePromptStore.usePromptAnswer(key) || profilePromptStore.isAnswerValue(profile?.[key])

  const canAnswer = profilePromptStore.isAnswerValue(form.values?.[key])

  return { onUpdateProfile, isAnswered, form, item, canAnswer }
}

export type UseProfilePrompt = ReturnType<typeof useProfilePrompt>
